//import libraries
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Resolve } from '@angular/router';

//import constants
import { AppSettings } from '../constants/app-settings';
import { AppBackRoutes } from '../constants/app-back-routes';

//import classes
import {
    ProfileGeneralGet, ProfileGeneralPostIn,
    ProfileGeneralPostOut, UserMangActionAddEditIn, UserMangActionAddEditOut,
    UserMangActionUpdateIn, UserMangActionUpdateOut
} from '../classes/profile.model';

//import language
import { ProfileGeneralLang, ProfileUserLang } from '../languages/Profile.Lang';

//import services
import { GeneralService } from '../services/general.service';

@Injectable()

export class ProfileService implements Resolve<Observable<any>>{

    constructor(
        private http: HttpClient,
        private generalService: GeneralService,
    ) { }

    resolve() {
        return this.GeneralGetData();
    }

    GeneralGetData(): Observable<ProfileGeneralGet> {

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.profileGeneralGet;
        return this.http.get<any>(url);

    }

    GeneralGetLangData(resp: ProfileGeneralGet) {

        if (!resp)
            return;

        let lang = {};

        let gen = resp.language.general;
        lang = Object.assign(lang, { general: this.generalService.service_inject(ProfileGeneralLang.general, gen) });

        let dash = resp.language.profile;
        lang = Object.assign(lang, { profile: this.generalService.service_inject(ProfileGeneralLang.profile, dash) });

        return lang;
    }

    GeneralGetServData(resp: ProfileGeneralGet) {
        return (resp) ? resp.profileData : null;
    }

    GeneralPostData(data: ProfileGeneralPostIn) {

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.profileGeneralPost;
        return this.http.post<ProfileGeneralPostOut>(url, data);
    }

    UserLangData(resp: ProfileGeneralGet) {

        if (!resp)
            return;

        let lang = {};

        let gen = resp.language.general;
        lang = Object.assign(lang, { general: this.generalService.service_inject(ProfileUserLang.general, gen) });

        let dash = resp.language.profile;
        lang = Object.assign(lang, { user: this.generalService.service_inject(ProfileUserLang.user, dash) });

        return lang;
    }

    UserServData(resp: ProfileGeneralGet) {
        return (resp) ? resp.subUsersData : null;
    }

    Useremailcheck(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.profileUserManagement;
        return this.http.post<any>(url, data, { headers: new HttpHeaders({'loader': 'false'}) });
    }

    UserMangActionAddEdit(data: UserMangActionAddEditIn) {

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.profileUserManagement;
        return this.http.post<UserMangActionAddEditOut>(url, data);

    }

    UserMangActionUpdate(data: UserMangActionUpdateIn) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.profileUserManagement;
        return this.http.post<UserMangActionUpdateOut>(url, data);
    }

    UserMangSortUpdate(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.profileUserMangSort;
        return this.http.post<any>(url, data, { headers: new HttpHeaders({'loader': 'false'}) });
    }

}